<template>
  <div class="home" v-if="$store.state.category && $store.state.categoryOption">
    <div class="g-wrap">
      <Tophead></Tophead>
      <NavTab></NavTab>
      <div class="inner-cont">
        <div class="g-wrap">
          <div
            class="bread-box"
            :class="{ 'no-border': $route.path === '/FirstHome' }"
          >
            <Breadcrumb></Breadcrumb>
          </div>
          <router-view />
        </div>
      </div>
    </div>
    <BottomLink></BottomLink>
    <FooterInfo></FooterInfo>
  </div>
</template>

<script>
import { getCategory, getCategoryOption } from "@/api/category";
import Tophead from "@/components/Tophead.vue";
import NavTab from "@/components/NavTab.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import BottomLink from "@/components/BottomLink.vue";
import FooterInfo from "@/components/FooterInfo.vue";
import { getSiteIdByDhSiteInfo } from "@/api/grzx";
export default {
  name: "Home",
  components: {
    Tophead,
    NavTab,
    Breadcrumb,
    BottomLink,
    FooterInfo,
  },
  created() {
    this.getCategory();
    //this.initWebRouter()
  },
  methods: {
    getCategory() {
      getCategory().then((res) => {
        this.$store.commit("setCategory", res);
      });
      getCategoryOption().then((res) => {
        this.$store.commit("setCategoryOption", res);
      });
    },
    initWebRouter() {
      if (localStorage.getItem("webid") !== null) {
        return;
      }
      let queryVal = this.$router.currentRoute.query;
      getSiteIdByDhSiteInfo({ pcSiteId: queryVal.webid }).then((res) => {
        localStorage.setItem("webid", res.data.data);
      });
    },
  },
};
</script>
<style scoped>
@import "./../assets/styles/normalize.css";
@import "./../assets/styles/page.css";
</style>
<style scoped>
.bread-box {
  height: 35px;
  line-height: 35px;
  margin: 0 12px;
  border-bottom: 1px solid #eee;
}
.bread-box.no-border {
  border: 0;
}
.bread-box .ant-breadcrumb {
  height: 35px;
  line-height: 35px;
}
</style>
